module.exports = __webpack_public_path__ + "static/media/AB_K17_5.6fd1bdd4.jpg";